import React, { FC } from 'react';
import ReactPaginate from 'react-paginate';
import { useDevice } from '../../../../../constants/device/device';
import { ReactComponent as ArrowLeft } from '../../../../../icons/chevron-left.svg';
import { ReactComponent as ArrowRight } from '../../../../../icons/chevron-right.svg';
import { ReactComponent as ThreeDots } from '../../../../../icons/three-dots.svg';
import { PaginationContainer } from './pagination.styles';

interface Props {
	numberOfGroups: number;
	onChange: (value: number) => void;
	marginPagesDisplayed?: number;
	pageRangeDisplayed?: number;
}

const Pagination: FC<Props> = ({ numberOfGroups, onChange, marginPagesDisplayed, pageRangeDisplayed }) => {
	const { mobileDevice } = useDevice();

	return (
		<PaginationContainer>
			<ReactPaginate
				previousLabel={<ArrowLeft />}
				nextLabel={<ArrowRight />}
				breakLabel={<ThreeDots />}
				breakClassName="break-me"
				pageCount={numberOfGroups}
				marginPagesDisplayed={marginPagesDisplayed || mobileDevice ? 1 : 2}
				pageRangeDisplayed={pageRangeDisplayed || mobileDevice ? 1 : 5}
				onPageChange={val => onChange(val.selected)}
				containerClassName="pagination"
				activeClassName="active"
				disabledClassName="disabled"
				previousClassName={'previous ' + (numberOfGroups > 2 && 'shifted')}
				nextClassName={'next ' + (numberOfGroups > 2 && 'shifted')}
			/>
		</PaginationContainer>
	);
};

export default Pagination;
